function SvgSuperhost(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_48_190" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_48_190)">
        <path d="M20.9022 10.3572C20.7089 9.85671 20.2445 9.53333 19.7192 9.53333H6.75318L8.00261 7.06651H18.1967C18.7295 7.06651 19.1668 6.63534 19.1923 6.08503C19.2064 5.80227 19.1099 5.52584 18.9255 5.32126C18.743 5.11549 18.4882 4.99917 18.222 5H7.23442C7.03431 5 6.85207 5.10816 6.74517 5.292L4.13826 10.1237C3.95585 10.4375 3.95385 10.8143 4.13275 11.1314C4.29577 11.4204 4.60294 11.5998 4.93485 11.5998H18.0237L12.6368 17.0976L12.0266 16.4398C11.8363 16.2364 11.5774 16.1219 11.3072 16.1216H11.3044C11.0415 16.1224 10.7988 16.2298 10.6204 16.4243C10.4447 16.6153 10.3459 16.8712 10.3448 17.1382C10.3422 17.4123 10.443 17.676 10.6245 17.8708L12.5993 20L20.6117 11.8227C20.9909 11.4358 21.1019 10.8742 20.9022 10.3572Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default SvgSuperhost;
